module.exports = __webpack_public_path__ + "0f03de99396ce07669f6f7347289624a.svg";